export enum CtaTypes {
    ADD_TO_BAG = 'add_to_bag',
    ADD_TO_COLLECTION = 'add_to_collection',
    DEFAULT = 'default',
    FIND_IN_STORE = 'find_in_store',
    HIDE_CTA = 'hide_cta',
    LINK = 'link',
    NOTIFY_ME = 'notify_me',
    PREORDER = 'preorder',
    SHOP_NOW = 'shop_now'
}
